var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"l-auth"},[_c('div',{staticClass:"l-auth__page"},[_c('header'),_c('main',{staticClass:"l-auth__content"},[_vm._t("default")],2),_c('auth-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }